module.exports = __webpack_public_path__ + "static/media/libra.896afbb3.svg";